export function toAdminApiPath(path: string): string {
  if (!path.startsWith("/api/") || path.startsWith("/api/admin/")) {
    return path;
  }

  return `/api/admin${path.slice("/api".length)}`;
}
